import alfaSlabOne400 from "./fonts/alfa-slab-one-latin-400-normal.woff2?inline";
import fredoka400 from "./fonts/fredoka-latin-400-normal.woff2?inline";
import fredoka700 from "./fonts/fredoka-latin-700-normal.woff2?inline";
import oswald400 from "./fonts/oswald-latin-400-normal.woff2?inline";
import oswald700 from "./fonts/oswald-latin-700-normal.woff2?inline";

/**
 * Les polices de l'affiche, embarquees dans le bundle (licence SIL OFL 1.1, textes dans
 * `fonts/OFL-*.txt`, fichiers tires des paquets @fontsource 5.3.0, sous-ensemble latin).
 *
 * Elles servent deux fois : chargees dans la page pour mesurer les noms (canvas), et
 * encodees dans le SVG de l'affiche, sans quoi l'image (apercu comme PNG exporte) les
 * ignore. Les familles portent un nom propre a l'app pour ne jamais tomber sur une
 * police du meme nom installee sur la machine du visiteur.
 */
export interface FontFaceDef {
  family: string;
  weight: number;
  src: string;
}

export const FONT_FACES: readonly FontFaceDef[] = [
  { family: "Concerts Nuit", weight: 700, src: oswald700 },
  { family: "Concerts Nuit", weight: 400, src: oswald400 },
  { family: "Concerts Ete", weight: 700, src: fredoka700 },
  { family: "Concerts Ete", weight: 400, src: fredoka400 },
  { family: "Concerts Atelier", weight: 400, src: alfaSlabOne400 },
];

/** Les regles @font-face d'une famille (ou de toutes), pretes pour un <style>. */
export function fontFaceCss(family?: string): string {
  return FONT_FACES.filter((face) => family === undefined || face.family === family)
    .map(
      (face) =>
        `@font-face{font-family:"${face.family}";font-weight:${face.weight};font-style:normal;src:url("${face.src}") format("woff2");}`,
    )
    .join("");
}

let installed: Promise<void> | null = null;

/**
 * Charge les polices dans la page, une seule fois. Rend une promesse resolue quand elles
 * sont pretes (ou tout de suite si le navigateur ne connait pas FontFace).
 */
export function installFonts(): Promise<void> {
  if (installed) {
    return installed;
  }
  if (typeof FontFace === "undefined" || typeof document === "undefined" || !document.fonts) {
    installed = Promise.resolve();
    return installed;
  }
  installed = Promise.all(
    FONT_FACES.map(async (face) => {
      const font = new FontFace(face.family, `url("${face.src}") format("woff2")`, {
        weight: String(face.weight),
      });
      document.fonts.add(await font.load());
    }),
  ).then(
    () => undefined,
    () => undefined,
  );
  return installed;
}

/** Pour les tests : oublie l'installation precedente. */
export function resetFontsForTests(): void {
  installed = null;
}
